import { render, staticRenderFns } from "./QuillCustom.vue?vue&type=template&id=8d28eb0e&"
import script from "./QuillCustom.vue?vue&type=script&lang=js&"
export * from "./QuillCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports